(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.directive('vvScaledBackgroundImage', function(vv) {
    return {
      priority: 0,
      restrict: 'A',
      scope: {
        src: '@vvScaledBackgroundImage',
        size: '@vvSize',
        ratio: '@vvRatio'
      },
      link: function(scope, element, attrs) {
        function setSrc() {
          if (!scope.src)
          return;

          var src = scope.src;
          var width = scope.size || attrs['width'];
          if (width) {
            var ratio = parseInt(scope.ratio);
            if (!ratio) {
              if (vvBrowser.isMobile())
              ratio = 1;
              else
              ratio = 2;
            }
            src = vv.resizedImageUrl(src, width, ratio);
          }
          element.css('background-image', 'url(' + vv.adjustProtocol(src) + ')');
        }
        scope.$watchGroup(['src', 'size', 'ratio'], function() {
          setSrc();
        });
        setSrc();
      }
    };
  });
})(window, window.angular);
